/* eslint-disable */
import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M15 6H5V8H15V6Z" }),
    React.createElement("path", { d: "M15 10H5V12H15V10Z" }),
    React.createElement("path", { d: "M15 14H5V16H15V14Z" }),
    React.createElement("path", { d: "M19.6154 23H4.38462C2.51462 23 1 21.4854 1 19.6154V1.00001H18.7692V4.40155H23V19.6154C23 21.4854 21.4854 23 19.6154 23ZM2.69231 2.69232V19.6154C2.69231 20.5462 3.45385 21.3077 4.38462 21.3077H19.6154C20.5462 21.3077 21.3077 20.5462 21.3077 19.6154V6.09385H18.7692V19.6069H17.0769V2.69232H2.69231Z" })), 'NewsOutlined');
